export enum OverFlowTypes {
    HIDDEN = 'hidden',
    AUTO = 'auto',
    SCROLL = 'scroll',
    VISIBLE = 'visible',
}

export enum DSClassNames {
    DSScrollbar = 'ds-scrollbar',
    DSScrollbarInverse = 'ds-scrollbar-inverse',
}

export enum FeatureNames {
    EGV = 'egv',
    SLOTS = 'slots',
    SEARCHCANCEL = 'searchcancel',
    NAVBAR = 'navbar',
    CUSTOMCAROUSEL = 'customCarousel',
    VIDEOTILE = 'videotile',
}
export enum DSVariant {
    Filled = 'filled',
    Outline = 'outline',
    Flat = 'flat',
    FlatReduced = 'flat-reduced',
}

export enum DSKind {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    Success = 'success',
    Utility = 'utility',
}

export enum CasinoThemeEnum {
    Betboo = 'betboo',
    BetbooBr = 'betboo-br',
    Borgata2 = 'borgata-2',
    BorgataCasino2 = 'borgata-casino-2',
    Bwin = 'bwin',
    BwinDark = 'bwin-dark',
    CheekyBingo2 = 'cheeky-bingo-2',
    Coral = 'coral',
    DanskeSpil = 'danske-spil',
    Enspire = 'enspire',
    FoxyBingo5 = 'foxy-bingo-5',
    FoxyGames3 = 'foxy-games-3',
    GalaBingo3 = 'gala-bingo-3',
    GalaCasino2 = 'gala-casino-2',
    Gamebookers = 'gamebookers',
    Giocodigitale = 'giocodigitale',
    Ladbrokes = 'ladbrokes',
    LadbrokesDe = 'ladbrokes-de',
    Mgm3 = 'mgm-3',
    Mgm4 = 'mgm-4',
    PartyCasino = 'party-casino',
    PartyCasino2 = 'party-casino-2',
    PartyPoker = 'party-poker',
    Premium = 'premium',
    PremiumDark = 'premium-dark',
    Slotclub = 'slotclub',
    Sportingbet = 'sportingbet',
    Sportingbet2 = 'sportingbet-2',
    SportingbetBr = 'sportingbet-br',
    SportsInteraction = 'sports-interaction',
    Vistabet = 'vistabet',
    WheelOfFortune = 'wheel-of-fortune',
}
